import {} from "@mui/material";
import type React from "react";
import type { ShipperCargoCreatePageProps } from "../model";
import { CargoCreateInProgress } from "./in-progress";
import { CargoCreatePreview } from "./preview";

export const ShipperCargoCreatePageUi: React.FC<ShipperCargoCreatePageProps> = (
  props,
) => {
  if (props.previewValues) {
    return <CargoCreatePreview {...props} />;
  }
  return <CargoCreateInProgress {...props} />;
};
